import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingHeaderPhoneProps {
  phone: string;
}

export const NewbuildingHeaderPhone: React.FC<INewbuildingHeaderPhoneProps> = ({ phone }) => {
  return (
    <div className={styles['phone']} data-testid="Phone">
      <UIHeading2>{phone}</UIHeading2>
    </div>
  );
};
